import { OwcTypography } from '@one/react';
import { useTranslation } from 'core/i18n';
import { GenericErrorLayout } from './generic-error.style';

export const LoadErrorMessageComponent: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <GenericErrorLayout>
      <img src="/assets/images/generic-error.svg" alt={t('components.workflow-error.alt')} />
      <OwcTypography variant="body1" mode="regular" className="text-center">
        {t('components.workflow-error.message')}
      </OwcTypography>
    </GenericErrorLayout>
  );
};
